import fetch from '@/plugins/fetch'
import queryString from 'query-string'

const http = async (...args) => {
  try {
    const response = await fetch(...args)
    const res = await response.json()
    return res
  } catch (e) {
    return {}
  }
}

http.get = async (url, params = {}) => {
  try {
    const qs = queryString.stringify(params)
    const qsText = qs ? `?${qs}` : ''
    const response = await fetch(`${url}${qsText}`)
    const res = await response.json()
    return res
  } catch (e) {
    return {}
  }
}

http.post = async (url, body = {}) => {
  try {
    Object.keys(body).forEach(i => {
      if (typeof body[i] === 'object') {
        body[i] = JSON.stringify(body[i])
      }
    })
    const qs = queryString.stringify(body)
    const response = await fetch(`${url}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      method: 'POST',
      body: qs,
      credentials: 'include'
    })
    const res = await response.json()
    return res
  } catch (e) {
    return {}
  }
}

export default http
